import request from "./httpService";

const PRESCRIPTION_ENDPOINT = '/rx';
const PRINT_ENDPOINT = '/print';

const save = (data) => {
    return request({
        method: "POST",
        url: `${PRESCRIPTION_ENDPOINT}/new`,
        data: data,
    });
};

const createRx = (data) => {
    return request({
        method: "POST",
        url: `${PRESCRIPTION_ENDPOINT}/new`,
        data: data,
    });
};

const update = (data) => {
    return request({
        method: "PUT",
        url: `${PRESCRIPTION_ENDPOINT}/${data.id}`,
        data: data,
    });
};

const getById = (id) => {
    return request({
        method: "GET",
        url: `${PRESCRIPTION_ENDPOINT}/${id}`,
    });
};

const getByCustomerId = (customerId, signal) => {
    return request({
        method: "GET",
        url: `${PRESCRIPTION_ENDPOINT}/customer/${customerId}`,
        signal: signal
    });
};

const getWithLimit = (from, to, filters, sortBy, customerId, signal) => {
    return request({
        method: "GET",
        url: `${PRESCRIPTION_ENDPOINT}/withlimit/${from}/${to}`,
        params: { filters: filters, sortBy: sortBy, customerId: customerId },
        signal: signal
    });
};

const deletePrescription = (ids) => {
    return request({
        method: "DELETE",
        url: `${PRESCRIPTION_ENDPOINT}`,
        params: { rowid: ids },
    });
};

const print = (id) => {
    
    return request({
        method: "GET",
        url: `${PRINT_ENDPOINT}/rx/${id}`,
        responseType: 'blob',
    });
};

const printTest = () => {
    return request({
        method: "GET",
        url: `${PRINT_ENDPOINT}/test`,
        responseType: 'blob',
    });
};

export const RxService = {
    save,
    createRx,
    update,
    getById,
    getByCustomerId,
    getWithLimit,
    deletePrescription,
    print,
    printTest
};